






import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import Dialog from '@/components/dialog.vue';
import moment from 'moment';
import { post } from '@/unite/api';
@Component({
  components: { SearchPaginationTable, Dialog }
})
export default class RunningwaterDetails extends Vue {
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  optionTitle: string = '';
  visible: boolean = false;
  modifyForm: any;
  rules: any[] = [];
  pageData: any = {
    url: '/back/v1/dpt/list',
    isSearch: false, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      page_num: 10,
      page_index: 1
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'name', // 字段
        tip: '部门',
        placeholder: '请输入要查询的部门'
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '添加部门',
        methods: 'add',
        type: 'success',
        loading: false
      },
      {
        name: '导出部门',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: true,
      header: [
        // {
        //   prop: 'id',
        //   label: 'ID'
        // },
        {
          prop: 'name',
          label: '部门'
        },
        {
          prop: 'modify_user',
          label: '上次修改人'
        }
      ],
      expand: [],
      optionWidth: 150,
      option: [
        {
          name: '修改部门',
          methods: 'modify',
          type: 'success',
          role: function(row: any) {
            return 1;
          }
        }
      ]
    } // table
  };
  dialogAddData: any = {
    modifyForm: {
      url: '/back/v1/dpt/create',
      width: '35%',
      form: {
        name: ''
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'name',
          name: '部门名称'
        }
      ],
      select: {
        role: []
      }
    },
    rules: {
      name: [
        {
          required: true,
          message: '请输入部门名称',
          trigger: 'blur'
        }
      ]
    }
  };
  dialogModifyData: any = {
    modifyForm: {
      url: '/back/v1/dpt/modify',
      width: '35%',
      form: {
        name: '',
        id: 0
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'id',
          name: 'ID',
          disabled: true
        },
        {
          type: 'input',
          model: 'name',
          name: '部门名称'
        }
      ],
      select: {
        role: []
      }
    },
    rules: {
      name: [
        {
          required: true,
          message: '请输入部门名称',
          trigger: 'blur'
        }
      ]
    }
  };
  private handleClick(methods: string, row: any) {
    if (methods === 'modify') {
      this.optionTitle = '修改部门';
      this.dialogModifyData.modifyForm.form.id = row.id;
      this.dialogModifyData.modifyForm.form.name = row.name;
      this.visible = true;
      this.modifyForm = this.dialogModifyData.modifyForm;
      this.rules = this.dialogModifyData.rules;
    }
  }
  private btnClick(methods: string) {
    if (methods === 'add') {
      this.optionTitle = '添加部门';
      this.visible = true;
      this.modifyForm = this.dialogAddData.modifyForm;
      this.rules = this.dialogAddData.rules;
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
  }
}
